// Sprint-014 C1 (config-page-ia-layout-2026-07-10.md §9) — the Config
// page's "navigate away with unsaved changes" guard. A single, app-wide
// slot (not a stack — unlike `hooks/useModalA11y.ts`'s overlay stack, at
// most ONE full-page "are you dirty" guard can ever be relevant at a time
// in this app, since only one routed view is ever mounted) that a page can
// register itself into while it holds unsaved edits.
//
// **Scope, flagged honestly (not silently claimed complete):** this guards
// every navigation that goes through `app.tsx`'s own `onNavigate`/`TabBar`
// `onChange` plumbing — i.e. every Sidebar row click, wordmark click, and
// phone TabBar tap. It does NOT intercept the browser/hardware Back button
// (a real `popstate` on the app's OWN route history, as opposed to the
// ephemeral overlay-stack entries `useModalA11y` manages) — wiring that
// would mean giving every real route navigation its own `pushState` entry
// app-wide, a materially larger change than this one page's build task.
// Noted in the sprint-014 C1 handoff for QA/debt-register awareness.
let guard: (() => Promise<boolean>) | null = null;

/** Registers (or clears, with `null`) the current "confirm before
 * navigating away" check. Only ever one page holds this at a time —
 * a page that mounts a guard is responsible for clearing it on unmount. */
export function setNavGuard(fn: (() => Promise<boolean>) | null): void {
  guard = fn;
}

/** Resolves `true` when navigation should proceed — either no guard is
 * registered, or the registered guard itself resolved `true` (the user
 * confirmed discarding their unsaved edits). */
export async function confirmNavigation(): Promise<boolean> {
  if (!guard) return true;
  return guard();
}
